import { getDeviceOS, selectMainCamera } from '@src/utils/permisssion.ts'
import { store } from '@src/redux/store.ts'
import { setCameraDeviceId } from '@src/redux/reducer/device.ts'

const permissionList = {
  // 모션 센서 권한 요청 설정
  motion: {
    name: '모션',
    request: async (onSuccess: any, onFailed: any) => {
      // @ts-ignore
      const isSafariOver13 = typeof DeviceMotionEvent?.requestPermission === 'function'
      /**  Safari 13 이상에서는 DeviceMotionEvent.requestPermission 함수를 사용 **/
      if (isSafariOver13) {
        try {
          // @ts-ignore
          const state = await DeviceOrientationEvent?.requestPermission()

          if (state === 'granted') {
            onSuccess()
          } else if (state === 'denied') {
            onFailed('모션 거절 팝업 클릭')
          }
        } catch (err) {
          return onFailed(err)
        }
      } else {
        /** Safari 13 이하 또는 다른 브라우저에서는 바로 성공처리 **/
        const isDesktop = !getDeviceOS()
        if (isDesktop) {
          return onSuccess()
        }
        const onDeviceOrientation = () => {
          onSuccess()
        }
        window.addEventListener('deviceorientation', onDeviceOrientation, { once: true })
      }
    },
  },
  // 카메라 권한 요청 설정
  camera: {
    name: '카메라',
    request: async (onSuccess: any, onFailed: any) => {
      try {
        let stream: any
        let isStreamSuccess = false

        // 미디어 디바이스 정보를 가져와 카메라 디바이스를 선택
        let mediaDevices: MediaDeviceInfo[] = await navigator.mediaDevices.enumerateDevices()
        const firstEnumerateDevicesCount = mediaDevices.length
        let mediaDeviceCameras: MediaDeviceInfo[] = mediaDevices.filter(({ kind }) => kind === 'videoinput')
        let mainCameraDevice = selectMainCamera(mediaDeviceCameras, 'back')
        let deviceId = mainCameraDevice?.deviceId

        const baseConstraints = {
          audio: false,
          video: { width: 1280, height: 720 },
        }

        try {
          stream = await navigator.mediaDevices.getUserMedia({
            ...baseConstraints,
            video: { ...baseConstraints.video, deviceId },
          })
          isStreamSuccess = true
          mediaDevices = await navigator.mediaDevices.enumerateDevices()
          const secoundEnumerateDevicesCount = mediaDevices.length

          if (firstEnumerateDevicesCount !== secoundEnumerateDevicesCount) {
            mediaDeviceCameras = mediaDevices.filter(({ kind }) => kind === 'videoinput')
            mainCameraDevice = selectMainCamera(mediaDeviceCameras, 'back')
            deviceId = mainCameraDevice?.deviceId

            stream = await navigator.mediaDevices.getUserMedia({
              ...baseConstraints,
              video: { ...baseConstraints.video, deviceId: deviceId },
            })
            isStreamSuccess = true
          }
        } catch (err) {
          // 권한 요청 실패 시 처리
          stream = await navigator.mediaDevices.getUserMedia({
            ...baseConstraints,
            video: { ...baseConstraints.video, facingMode: 'environment' },
          })
          isStreamSuccess = true
          onFailed(err)
        } finally {
          /** TODO: catch에서 stream 불러오다 err나면 그냥 finally가 실행되고 success가 될텐데 고민이 필요 */
          /** TODO: isStreamSuccess 값을 통해 finally에서 바깥 catch로 보내는 로직 추가, 테스트 이상 무, 혹시 모르니 메모 */
          if (!isStreamSuccess) {
            throw new Error('stream is not success')
          }

          store.dispatch(setCameraDeviceId(deviceId))

          stream.getVideoTracks().forEach((track: any) => {
            track.stop()
          })
          onSuccess()
        }
      } catch (err) {
        return onFailed(err)
      }
    },
  },
  // GPS 권한 요청 설정
  gps: {
    name: '위치',
    request: (onSuccess: any, onFailed: any) => {
      const geolocationOptions = {
        enableHighAccuracy: true,
        timeout: 1000 * 60, // 1 min (1000 ms * 60 sec * 1 minute = 60 000ms)
        maximumAge: 0,
      }
      const { geolocation } = navigator
      if (!geolocation) return onFailed('Could not found window.navigator.geolocation')
      geolocation.getCurrentPosition(onSuccess, (e) => onFailed(e), geolocationOptions)
    },
  },
}

export default permissionList
